module.exports = __webpack_public_path__ + "media/application/images/projects/images/the_netherlands-17a4c46f9bc5b7035e3c452e9ab3226e.jpg";